/**
 * exatrek REST API
 * Some custom description of API.
 *
 * The version of the OpenAPI document: v3
 * Contact: dev@exatrek.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MachineIdDto } from './machineIdDto';
import { ImplementIdDto } from './implementIdDto';
import { LocationIdDto } from './locationIdDto';
import { EmployeeIdDto } from './employeeIdDto';
import { ExaAdapterIdDto } from './exaAdapterIdDto';

export interface WorkingtimeOnMachineV2Dto {
  adapter?: ExaAdapterIdDto;
  color?: string;
  employee?: EmployeeIdDto;
  id?: number;
  implement?: ImplementIdDto;
  jobId?: number;
  location?: LocationIdDto;
  machine?: MachineIdDto;
  start?: string;
  stop?: string;
}
